
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/utrzymanie-i-audyt-oprogramowania",
      function () {
        return require("private-next-pages/utrzymanie-i-audyt-oprogramowania.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/utrzymanie-i-audyt-oprogramowania"])
      });
    }
  